import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  AvatarContainer,
  AvatarImage,
  AvatarSize,
  AvatarText,
  AvatarVariant,
} from './Avatar.styles';

interface Props {
  variant: AvatarVariant;
  size: AvatarSize;
  text?: string;
  image?: string;
  dark?: boolean;
  'data-testid'?: string;
  onClick?: () => void;
  textColor?: string;
}

export const Avatar = ({
  variant = 'icon',
  size = 'large',
  text,
  image,
  dark = false,
  textColor,
  ...props
}: Props) => {
  const theme = useTheme();
  const iconSize = {
    small: '15px',
    medium: '20px',
    large: '34px',
  };
  switch (variant) {
    case 'icon':
      return (
        <AvatarContainer
          size={size}
          data-testid={props['data-testid']}
          dark={dark}
          {...props}
        >
          <StyledIcon
            className="uil uil-user"
            size={iconSize[size]}
            color={
              dark
                ? theme.atlas.semantic.color.type.inverse
                : theme.atlas.core.color.gray[950]
            }
          />
        </AvatarContainer>
      );

    case 'text':
      if (text?.length === 2) {
        return (
          <AvatarContainer
            size={size}
            data-testid={props['data-testid']}
            dark={dark}
            {...props}
          >
            <AvatarText
              size={size}
              color={
                textColor
                  ? textColor
                  : dark
                    ? theme.atlas.semantic.color.type.inverse
                    : theme.atlas.core.color.gray[950]
              }
            >
              {text}
            </AvatarText>
          </AvatarContainer>
        );
      }
      return (
        <AvatarContainer
          size={size}
          data-testid={props['data-testid']}
          {...props}
        >
          <AvatarText
            size={size}
            color={
              textColor
                ? textColor
                : dark
                  ? theme.atlas.semantic.color.type.inverse
                  : theme.atlas.core.color.gray[950]
            }
          >
            {text?.slice(0, 2)}
          </AvatarText>
        </AvatarContainer>
      );

    case 'image':
      return (
        <AvatarContainer
          size={size}
          data-testid={props['data-testid']}
          {...props}
        >
          <AvatarImage
            src={image}
            alt="avatar-image"
            size={size}
            color={
              dark
                ? theme.atlas.semantic.color.type.inverse
                : theme.atlas.core.color.gray[950]
            }
          />
        </AvatarContainer>
      );
  }
};
